import React from 'react'
import PropTypes from 'prop-types'
import  { AS } from '../../config/account'
import RegisterForm from './RegisterForm'
import RegConfirmation from './RegConfirmation'
import './index.css'

export class UserAccount extends React.Component {

  componentDidMount () {
    const { emailVerified, goToUser } = this.props
    if (!emailVerified) {
      goToUser()
    }
  }

  render () {
    const { as, regData } = this.props.account
    let form
    switch (as) {
      case AS.DEMO:
      case AS.DEMO_OC:
        form = <RegisterForm title='Objednávka plné verze' />
        break
      case AS.FULL_OC:
      case AS.FULL_OD:
        form = <RegisterForm title='Obnovení plné verze' />
        break
      case AS.FULL:
        form = <RegisterForm title='Navýšení předplatného' />
        break
      default:
        form = <RegConfirmation regData={regData} accountState={as} />
    }
    return (
      <div className='ap-con'>
        {form}
      </div>
    )
  }
}

UserAccount.propTypes = {
  account: PropTypes.object,
  userName: PropTypes.string
}

export default UserAccount



// WEBPACK FOOTER //
// ./src/components/UserAccount/indexC.js